module.exports = __webpack_public_path__ + "static/media/resourcesHeader.1c6a1c5b.jpg";